import { Outlet } from "react-router-dom"
import { AppNavBar } from "./AppNavBar"
import { BsToast } from "./BsToast"

export const MasterLayout = ({children}) => {
    return (
        <>
            <AppNavBar/>
            <Outlet/>

            <BsToast />
        </>
    )
}